var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useCallback, useRef } from "react";
export var useItemEditor = function (_a) {
    var appendItem = _a.appendItem, updateItem = _a.updateItem, createEmpty = _a.createEmpty;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(null), editingIndex = _c[0], setEditingIndex = _c[1];
    var _d = useState(createEmpty()), draft = _d[0], setDraft = _d[1];
    var draftRef = useRef(draft);
    draftRef.current = draft;
    var createEmptyRef = useRef(createEmpty);
    createEmptyRef.current = createEmpty;
    var openEditor = useCallback(function (item, index) {
        if (item != null && typeof index === "number") {
            setEditingIndex(index);
            setDraft(__assign({}, item));
        }
        else {
            setEditingIndex(null);
            setDraft(createEmptyRef.current());
        }
        setIsOpen(true);
    }, []);
    /** Opens the editor for a new item whose empty draft is pre-filled by `seed`. */
    var openNew = useCallback(function (seed) {
        setEditingIndex(null);
        setDraft(__assign(__assign({}, createEmptyRef.current()), seed));
        setIsOpen(true);
    }, []);
    var closeEditor = useCallback(function () {
        setIsOpen(false);
        setEditingIndex(null);
    }, []);
    var saveItem = useCallback(function (override) {
        var currentDraft = override !== null && override !== void 0 ? override : draftRef.current;
        if (editingIndex !== null && editingIndex >= 0) {
            updateItem(editingIndex, currentDraft);
        }
        else {
            appendItem(currentDraft);
        }
        setIsOpen(false);
        setEditingIndex(null);
    }, [editingIndex, appendItem, updateItem]);
    return {
        isOpen: isOpen,
        isEditing: editingIndex !== null,
        editingIndex: editingIndex,
        draft: draft,
        setDraft: setDraft,
        openEditor: openEditor,
        openNew: openNew,
        closeEditor: closeEditor,
        saveItem: saveItem,
    };
};
